import { getTitoloI18n } from './titoloUtils'

// Titolo della sezione Mongo per ogni tipo (icona e nome del gruppo); Board non è una sezione.
export const SEZIONE_PER_TIPO = {
  clienti: 'Clienti',
  preventivi: 'Preventivi',
  fatture: 'Fatture',
  articoli: 'Articoli',
  ordini: 'Ordini',
  fornitori: 'Fornitori',
  cantieri: 'Cantieri',
  board: null
}

// Stessa regola del BE: 2 caratteri, 1 se sono solo cifre.
export const queryValida = testo => {
  const t = (testo || '').trim()
  return /^\d+$/.test(t) ? t.length >= 1 : t.length >= 2
}

// isPrivate '0' = azienda (intestazione), altrimenti nome e cognome.
const nomeCliente = c => {
  if (!c) return ''
  if (c.isPrivate === '0') return c.intestazione || ''
  return `${c.nome || ''} ${c.cognome || ''}`.trim() || c.intestazione || ''
}

export const formatHit = ({ tipo, campi = {} }) => {
  switch (tipo) {
    case 'clienti': return { titolo: nomeCliente(campi), sottotitolo: campi.email || '' }
    case 'preventivi':
    case 'fatture': return { titolo: `#${campi.numero}`, sottotitolo: nomeCliente(campi.cliente) }
    case 'articoli': return { titolo: getTitoloI18n(campi), sottotitolo: campi.referenza || '' }
    case 'ordini': return { titolo: campi.nOrdine || campi.numeroOrdine || '', sottotitolo: nomeCliente(campi.cliente) }
    case 'fornitori': return { titolo: campi.fornitore || '', sottotitolo: campi.email || '' }
    case 'cantieri': return { titolo: campi.codiceInstallazione || '', sottotitolo: [campi.descrizione, nomeCliente(campi.cliente)].filter(Boolean).join(' · ') }
    case 'board': return { titolo: campi.nome || '', sottotitolo: '' }
    default: return { titolo: '', sottotitolo: '' }
  }
}
